import { render, staticRenderFns } from "./groupManage.vue?vue&type=template&id=22b3072d"
import script from "./groupManage.vue?vue&type=script&lang=js"
export * from "./groupManage.vue?vue&type=script&lang=js"
import style0 from "./groupManage.vue?vue&type=style&index=0&id=22b3072d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports